module.exports = __webpack_public_path__ + "static/media/baseline-error.02d4f643.svg";